


















import { Component, Mixins } from 'vue-property-decorator';
import { ViewModes, Actions, Mutations } from '@/ts/store/Constants';
import DeviceMethods from '@/mixins/DeviceMethods.vue';
import { mapGetters } from 'vuex';
import LogIn from '@/views/User/LogIn.vue';
import AvailableUpdate from '@/views/User/AvailableUpdate.vue';
import Pin from '@/components/User/Pin.vue';
import MobileLoginErrorDialog from '@/components/Dialogs/MobileLoginErrorDialog.vue';
import { LocalizationHelpers } from '@/ts/helpers/LocalizationHelpers';


@Component({
    components: {
        LogIn,
        AvailableUpdate,
        Pin,
        MobileLoginErrorDialog,
    },
})
export default class InitialScreen extends Mixins(DeviceMethods) {
    constructor() {
        super();
    }

    get view() {
        return this.$store.getters['Viewport/getCurrentView'];
    }

    get availableUpdateVisible() {
        return this.$store.getters['User/getAvailableUpdateVisible'];
    }

    get wrongPinTries() {
        return this.$store.getters['User/getWrongPinCounter'];
    }

    get lastVersion() {
        return this.$store.getters['User/getLastVersion'];
    }

    get currentVersion() {
        return this.$store.getters['User/getCurrentVersion'];
    }

    get errorView() {
        return (this.view.viewMode === ViewModes.LogIn.ErrorView);
    }

    get loggingIn(): boolean {
        return this.$store.state.User.loggingIn;
    }

    get langaugeCode(): string {
        return this.$store.state.User.selectedLanguage;
    }

    get hasSavedCredentials(): boolean {
        return (
            this.$store.state.initialized &&
            this.$store.state.User.authData !== null &&
            this.$store.state.User.savedFullName !== '' &&
            this.wrongPinTries < 3
        );
    }

    get isUpdateAvailableScreen(): boolean {
        return ((this.mobileLayout || this.tabletLayout) && this.availableUpdateVisible && this.availableUpdate(this.currentVersion, this.lastVersion.version));
    }

    get isPinScreen(): boolean {
        return (!this.desktopLayout && !this.loggingIn && this.hasSavedCredentials);
    }

    get isLogInScreen(): boolean {
        return (this.desktopLayout || (this.mobileLayout && !this.hasSavedCredentials));
    }

    get isMobileErrorScreen(): boolean {
        return (this.mobileLayout && this.errorView);
    }

    public availableUpdate(current: string, last: string) {
        return (current !== last);
    }

    public async beforeCreate() {
        this.$store.commit(Mutations.SET_CURRENT_VERSION, HOCOCO_APP_VERSION);
        await this.$store.dispatch(Actions.GET_USER_LANGUAGE_CODE);
        this.$store.dispatch(Actions.GET_LAST_VERSION, this);
    }
}
